<form [formGroup]="form" novalidate (ngSubmit)="prepareForSave()">

  <h5 mat-dialog-title>{{modalTitle}}</h5>

  <!-- CONTENT -->
  <mat-dialog-content>

    @if (content) {
      <label for="inputLabel">{{content}}</label>
    }

    <input  type="text"
      id="inputLabel"
      class="form-control"
      formControlName="label"
      [placeholder]="currentLabel"
      [value]="currentLabel"
      >

      @if (etape_id) {
        <input id="etape_id" type="hidden" value="{{etape_id}}"/>
      }

      <!-- FORM MESSAGE -->
      @if (form.invalid && (label.dirty || label.touched) && this.formSubmitAttempt) {
        <p class="text-right">
          @if (label.errors.required) {
            <small class="danger text-muted">* Ce champs est requis</small>
          }
        </p>
      }


    </mat-dialog-content>

    <!-- ACTIONS -->
    <mat-dialog-actions>
      <button mat-button type="button" [mat-dialog-close]="false">{{cancel}}</button>
      <button mat-raised-button color="primary" type="submit">{{confirm}}</button>


    </mat-dialog-actions>

  </form>
